module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-profitability-forecasting-29f75d9dedcabed8f63b6e6e92c2b585.png";